import { types } from "mobx-state-tree";
import { createCustomReadonlyDictionary } from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";
import { MSURL } from "utils/ms";

const pathQuiz = "/quiz/api/v1";
const SectionDictionaryItem = types.model({
  id: types.number,
  title: types.string,
});

const SectionDictionary = createCustomReadonlyDictionary({
  itemModel: SectionDictionaryItem,
  fetch: async function() {
    return await api.get(
      `${pathQuiz}/section/slim-list`,
      undefined,
      undefined,
      MSURL,
    );
  },
  getValue: value => value,
  getLabel: ({ title }) => title,
});

export default SectionDictionary.create();
